/**
 * The country page's Errors view (19/10/2026): the error trace over today,
 * the last 7 or the last 30 run days, narrowed to the open campaign group.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';

import { useErrorsReport } from '../../hooks/useErrorQueries';
import { ErrorsTabCard } from './ErrorsTabCard';

export const ErrorsTab: FC<{
  countryKey: string;
  at: string | null;
  scopeIds?: ReadonlySet<string> | null;
  scopeLabel?: string | null;
  onEditContainer?: (containerId: string) => void;
}> = ({ countryKey, at, scopeIds = null, scopeLabel = null, onEditContainer }) => {
  const [days, setDays] = useState(7);
  const report = useErrorsReport(countryKey, days, at);
  return (
    <ErrorsTabCard
      report={report.data}
      loading={report.isLoading}
      failed={report.isError}
      onRetry={() => void report.refetch()}
      days={days}
      onDays={setDays}
      scopeIds={scopeIds}
      scopeLabel={scopeLabel}
      onEditContainer={onEditContainer}
    />
  );
};
